import { Outlet } from 'react-router-dom';

export function StoresRoot() {
  return (
    <Outlet/>
  );
}
